// src/components/CerpaxLogo.js
import React from 'react';
import { APP_VERSION } from '../config/appVersion';

const CerpaxLogo = ({ className = "app-logo" }) => (
  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <img
      src="/logo192.png"
      alt="Logo"
      style={{ height: '40px', width: 'auto' }}
    />
    <span style={{
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#1e3a8a',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.2'
    }}>
      Time
    </span>
    <span style={{
      fontSize: '9px',
      color: '#888',
      lineHeight: '1'
    }}>
      {APP_VERSION}
    </span>
  </div>
);

export default CerpaxLogo;